// extracted by mini-css-extract-plugin
module.exports = {"section":"K2_section__NZ7VZ"};